import { render, staticRenderFns } from "./PropertyNumberOrVariable.vue?vue&type=template&id=306d5909&"
import script from "./PropertyNumberOrVariable.vue?vue&type=script&lang=js&"
export * from "./PropertyNumberOrVariable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports